/**
 * Code promo panier / minicart — POST /cart/update.js { discount }.
 * https://shopify.dev/docs/api/ajax/reference/cart#update-discounts-in-the-cart
 */
(function () {
  'use strict';

  var STORAGE_OPEN = 'pebblePromoOpen';

  function rootPath() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function t(key, fallback) {
    var tr = window.Shopify && Shopify.translation;
    if (tr && tr[key]) return tr[key];
    if (tr && tr.cart && tr.cart[key]) return tr.cart[key];
    return fallback;
  }

  function interpret(cart, requestedCode) {
    var requested = String(requestedCode || '').trim();
    if (!requested) return { ok: false, reason: 'empty' };
    var codes = (cart && Array.isArray(cart.discount_codes)) ? cart.discount_codes : [];
    var match = codes.find(function (c) {
      return String(c && c.code || '').trim().toLowerCase() === requested.toLowerCase();
    });
    if (match && match.applicable) return { ok: true, reason: 'applied' };
    return { ok: false, reason: 'invalid' };
  }

  function applicableCodes(cart) {
    var codes = (cart && Array.isArray(cart.discount_codes)) ? cart.discount_codes : [];
    return codes
      .filter(function (c) {
        return c && c.applicable && String(c.code || '').trim();
      })
      .map(function (c) { return String(c.code).trim(); })
      .join(',');
  }

  function mergeCode(existing, code) {
    var next = String(code || '').trim();
    var list = String(existing || '').split(',').map(function (part) {
      return part.trim();
    }).filter(Boolean);
    if (!next) return list.join(',');
    var lower = next.toLowerCase();
    if (!list.some(function (part) { return part.toLowerCase() === lower; })) list.push(next);
    return list.join(',');
  }

  function remainingCodes(cart, removeCode) {
    var remove = String(removeCode || '').trim().toLowerCase();
    return applicableCodes(cart).split(',').filter(function (part) {
      return part && part.toLowerCase() !== remove;
    }).join(',');
  }

  function checkoutHidden(form) {
    if (!form || !form.id) return null;
    var formId = (window.CSS && CSS.escape) ? CSS.escape(form.id) : form.id;
    return document.querySelector('[data-pebble-promo-checkout][form="' + formId + '"]');
  }

  function writeCheckoutDiscount(form, codes) {
    var hidden = checkoutHidden(form);
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.setAttribute('data-pebble-promo-checkout', '');
      if (form.id) hidden.setAttribute('form', form.id);
      form.appendChild(hidden);
    }
    if (codes) {
      hidden.name = 'discount';
      hidden.value = codes;
    } else {
      hidden.removeAttribute('name');
      hidden.value = '';
    }
  }

  function setStatus(el, message, kind) {
    if (!el) return;
    if (!message) {
      el.hidden = true;
      el.textContent = '';
      el.removeAttribute('data-kind');
      return;
    }
    el.hidden = false;
    el.textContent = message;
    el.setAttribute('data-kind', kind || 'info');
  }

  function syncCheckoutHidden(root, value) {
    var hidden = root.querySelector('[data-pebble-promo-checkout]');
    if (!hidden) return;
    if (value) {
      hidden.name = 'discount';
      hidden.value = value;
    } else {
      hidden.removeAttribute('name');
      hidden.value = '';
    }
  }

  function postDiscount(code) {
    return fetch(rootPath() + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: String(code || '') })
    }).then(function (r) {
      if (!r.ok) throw new Error('http');
      return r.json();
    });
  }

  function refreshCart(cart) {
    document.dispatchEvent(new CustomEvent('updateCart', { detail: { cart: cart } }));
  }

  class PromotionCode extends HTMLElement {
    connectedCallback() {
      var details = this.querySelector('details');
      if (details && sessionStorage.getItem(STORAGE_OPEN) === '1') {
        details.setAttribute('open', '');
      }
      if (details) {
        details.addEventListener('toggle', function () {
          sessionStorage.setItem(STORAGE_OPEN, details.open ? '1' : '0');
        });
      }
      var form = this.querySelector('[data-pebble-promo-form]');
      var input = this.querySelector('.pebble-promo-form__input, input[type="text"][name="discount"]');
      var status = this.querySelector('[data-pebble-promo-status]');
      var submitBtn = this.querySelector('.pebble-promo-form__submit');
      var self = this;

      function apply(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        var code = input ? String(input.value || '').trim() : '';
        if (!code) {
          setStatus(status, t('promotion_empty', 'Saisissez un code promo.'), 'error');
          return false;
        }
        sessionStorage.setItem(STORAGE_OPEN, '1');
        if (submitBtn) submitBtn.disabled = true;
        fetch(rootPath() + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .catch(function () { return {}; })
          .then(function (current) {
            var previous = applicableCodes(current);
            return postDiscount(mergeCode(previous, code)).then(function (cart) {
              return { previous: previous, cart: cart };
            });
          })
          .then(function (result) {
            var cart = result.cart;
            var check = interpret(cart, code);
            if (!check.ok) {
              if (result.previous && applicableCodes(cart) !== result.previous) {
                return postDiscount(result.previous).then(function (restored) {
                  syncCheckoutHidden(self, applicableCodes(restored));
                  setStatus(
                    status,
                    t('promotion_invalid', 'Ce code n’est pas applicable.'),
                    'error'
                  );
                  if (submitBtn) submitBtn.disabled = false;
                  refreshCart(restored);
                });
              }
              setStatus(
                status,
                t('promotion_invalid', 'Ce code n’est pas applicable.'),
                'error'
              );
              if (submitBtn) submitBtn.disabled = false;
              return;
            }
            syncCheckoutHidden(self, applicableCodes(cart));
            if (input) input.value = '';
            refreshCart(cart);
          })
          .catch(function () {
            setStatus(status, t('promotion_invalid', 'Ce code n’est pas applicable.'), 'error');
            if (submitBtn) submitBtn.disabled = false;
          });
        return false;
      }

      if (form) {
        form.addEventListener('submit', apply);
      }
      if (submitBtn) {
        submitBtn.addEventListener('click', apply);
      }
      this.querySelectorAll('[data-pebble-promo-remove]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          btn.disabled = true;
          sessionStorage.setItem(STORAGE_OPEN, '1');
          fetch(rootPath() + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              return postDiscount(remainingCodes(cart, btn.getAttribute('data-pebble-promo-remove')));
            })
            .then(function (cart) {
              syncCheckoutHidden(self, applicableCodes(cart));
              refreshCart(cart);
            })
            .catch(function () {
              btn.disabled = false;
            });
        });
      });
    }
  }

  if (!customElements.get('promotion-code')) {
    customElements.define('promotion-code', PromotionCode);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart') === -1) return;
    var btn = e.submitter;
    if (!btn || btn.name !== 'checkout') return;
    if (form.dataset.pebbleDiscountReady === '1') {
      delete form.dataset.pebbleDiscountReady;
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    fetch(rootPath() + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        writeCheckoutDiscount(form, applicableCodes(cart));
      })
      .catch(function () {
        var hidden = checkoutHidden(form);
        writeCheckoutDiscount(form, hidden && hidden.value ? hidden.value : '');
      })
      .then(function () {
        form.dataset.pebbleDiscountReady = '1';
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(btn);
          return;
        }
        var checkoutInput = document.createElement('input');
        checkoutInput.type = 'hidden';
        checkoutInput.name = 'checkout';
        form.appendChild(checkoutInput);
        form.submit();
      });
  }, true);
})();
